import { REQUEST } from '../../../utils/actionGenerator';
import { fork, take } from 'redux-saga/effects';
import * as api from '../../../utils/api';
import { fetchEntity } from '../../../store/saga';
import * as createDemandActions from './actions';

export function* getFormConfig() {
  const request = api.getFormConfigRequest.bind();
  yield fetchEntity(request, createDemandActions.getFormConfig, null);
}

export function* getConsignerSuggestions(payload) {
  const request = api.getConsignerSuggestionsRequest.bind(null, payload);
  yield fetchEntity(request, createDemandActions.getConsignerSuggestions, payload);
}

export function* getViaPointsSuggestions(params) {
  const request = api.getViaPointsRequest.bind(null, params);
  yield fetchEntity(request, createDemandActions.getViaPointsSuggestions, params);
}

export function* getStartAddresses(payload) {
  const request = api.getAddressesRequest.bind(null, payload);
  yield fetchEntity(request, createDemandActions.getStartAddresses, payload);
}

export function* getEndAddresses(payload) {
  const request = api.getAddressesRequest.bind(null, payload);
  yield fetchEntity(request, createDemandActions.getEndAddresses, payload);
}

export function* createDemand(payload) {
  const request = api.createDemandRequest.bind(null, payload);
  yield fetchEntity(request, createDemandActions.createDemand, payload);
}

export function* addAddressDemand(payload) {
  const request = api.addAddressDemandRequest.bind(null, payload);
  yield fetchEntity(request, createDemandActions.addAddressDemand, payload);
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* watchGetFormConfigSaga() {
  while (true) {
    yield take(createDemandActions.GET_FORM_CONFIG[REQUEST]);
    yield fork(getFormConfig);
  }
}

export function* watchGetConsignerSuggestionsSaga() {
  while (true) {
    const { payload } = yield take(createDemandActions.GET_CONSIGNER_LIST[REQUEST]);
    yield fork(getConsignerSuggestions, payload);
  }
}

export function* watchGetStartAddressesSaga() {
  while (true) {
    const { payload } = yield take(createDemandActions.GET_START_ADDRESS[REQUEST]);
    yield fork(getStartAddresses, payload);
  }
}

export function* watchGetEndAddressesSaga() {
  while (true) {
    const { payload } = yield take(createDemandActions.GET_END_ADDRESS[REQUEST]);
    yield fork(getEndAddresses, payload);
  }
}

export function* watchCreateDemandSaga() {
  while (true) {
    const { payload } = yield take(createDemandActions.CREATE_DEMAND[REQUEST]);
    yield fork(createDemand, payload);
  }
}

export function* watchGetViaPointsSuggestionsSaga() {
  while (true) {
    const { params } = yield take(createDemandActions.GET_VIA_POINTS_SUGGESTIONS[REQUEST]);
    yield fork(getViaPointsSuggestions, params);
  }
}

export function* watchAddAddressDemandSaga() {
  while (true) {
    const { payload } = yield take(createDemandActions.ADD_ADDRESS[REQUEST]);
    yield fork(addAddressDemand, payload);
  }
}
